import {Item} from '../../types/packingSlipStatusResponse';
import {ShipmentItem} from '../../models/shipmentItem';

const convertPackingSlipItemToShipmentItem = (item: Item): ShipmentItem => {
    return {
        sku: item.shippable.sku,
        description: item.description,
        qty: item.qty,
        length: item.shippable.length,
        width: item.shippable.width,
        height: item.shippable.height,
        weight: item.shippable.weight,
        imageUrl: item.shippable.imageUrl,
        isSpecial: item.shippable.special,
        isBackorder: false, // todo: not available yet
    };
};

export default convertPackingSlipItemToShipmentItem;
